export default "__VITE_ASSET__BAutGEfX__"